import styled, { css } from 'styled-components';

export const Wrapper = styled.div`
  margin-left: 28.5rem;
  margin-top: 1rem;
  padding:5rem;
`;
